import { useTranslation } from 'react-i18next';

import { Icon, ICONS, PLATFORM_THEME_COLORS, Typography } from '@thinknet-gmbh/platform-common-ui';

import { IDocumentTemplate } from 'src/pages/jobs/jobs.interfaces';

import { DocumentsListWrapper, InfoElement } from './job-documents-list.styles';

const JobDetailsList = ({ document }: { document: any }) => {
  const { t } = useTranslation(['common', 'settings']);

  return (
    <DocumentsListWrapper>
      <InfoElement>
        <Typography>{`${t('common:labels.label')}:`}</Typography>
        <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
          {document.documentLabel.name}
        </Typography>
      </InfoElement>
      <InfoElement>
        <Typography weight="bold">{`${t(
          'settings:documents.labels.documentTemplate'
        )}:`}</Typography>
        <div>
          {document.documentTemplates.map((template: IDocumentTemplate) => (
            <InfoElement key={template._id}>
              <Icon icon={ICONS.file} />
              <Typography>{template.title}</Typography>
            </InfoElement>
          ))}
        </div>
      </InfoElement>
    </DocumentsListWrapper>
  );
};

export default JobDetailsList;
